import { EasyField } from '../baseClasses/easyField';
import { FieldOptions } from '../index';

export class EasyInputField extends EasyField {
  controlType = 'textbox';
  type: string;

  constructor(options: FieldOptions<any> = {}) {
    super(options);
    options.controlType = this.controlType;
    this.type = options['type'] || '';
  }
}
